//#region Asset Imports

import * as moment from 'moment'
import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/button'
import 'devextreme/ui/form'
import 'devextreme/ui/load_indicator'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../common.module'
import { SchemaModel, SchemaElement, SchemaElementApperance, FieldNameValueModel, FormValuesModel, ColumnModel } from '../../api/api.models'
import { CommonHelper } from '../../../helpers/common-helper'
import { i18n } from '../i18n/common.i18n'
import { Md5 } from '../../../helpers/md5-helper'
import { EventsNames } from '../../../helpers/events-names'
import { ThemeHelper } from '../../../helpers/theme-helper'
import { IUserSession } from '../../../helpers'

//#region Asset Imports

import './schema.scss'
import * as TEMPLATE from './schema.tpl.html'

//#endregion

interface SchemaSource {
    id?: number // id for location tab only!!!
    data?: SchemaModel
    isReadOnly: boolean
}

interface ImgPosition {
    top: number
    left: number
}

interface SchButton extends DevExpress.ui.dxButtonOptions {
    schemaNumber: number,
    value: string,
    cssClass: string,
    image: number[]
}

interface SchemaScope extends ng.IScope {
    source: SchemaSource
    schemaModel: SchemaModel
    isLoaded: boolean
    originalHeight: number
    originalWidth: number
    imgPosition: ImgPosition

    scaleX: number
    scaleY: number

    formOptions: DevExpress.ui.dxFormOptions
    form: ng.IDeferred<DevExpress.ui.dxForm>
    formData: any
    items: any[]

    gotoBtns: any[]

    applyButtonOptions: DevExpress.ui.dxButtonOptions
    isApplyButtonDisabled: boolean
    units: ColumnModel[]

    id: any
    schemaOwner: any
}

export class SchemaDirective implements ng.IDirective {

    gotoAction: (e) => void

    previousModelMd5: string
    requestFailed: boolean = false

    constructor() {
    }

    restrict = 'E'
    scope = {
        source: '=',
        id: '=?',
        schemaOwner: '='
    }
    template = TEMPLATE

    controller = ['$scope', '$element', '$q', '$timeout', 'api', 'logger', 'localDictionary', '$window', 'userSession', ($scope: SchemaScope, $element: JQuery, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, logger: LoggerService, localDictionary: LocalDictionaryFactory, $window: ng.IWindowService, userSession: IUserSession) => {
        if ($scope.id == null) $scope.id = Date.now()
        $scope.items = []
        $scope.gotoBtns = []
        $scope.formData = {}
        $scope.isApplyButtonDisabled = true
        $scope.form = $q.defer<DevExpress.ui.dxForm>()

        var units = localDictionary.getUnits().then(result => {
            $scope.units = result
        })

        var lastResizeTimeout
        var resize = () => {
            if ($scope.isLoaded) {
                if (lastResizeTimeout) $timeout.cancel(lastResizeTimeout)
                lastResizeTimeout = $timeout(() => {
                    var actualImg = $element.find('.schema')

                    $scope.scaleX = actualImg.width() / $scope.originalWidth
                    $scope.scaleY = actualImg.height() / $scope.originalHeight
                    $scope.imgPosition = actualImg.position()

                    if ($scope.schemaModel && $scope.schemaModel.schemaConfiguration) {
                        if ($scope.items) {
                            $scope.items.forEach(input => {
                                var number = input.schemaNumber;
                                var sc = $scope.schemaModel.schemaConfiguration[number]
                                if (sc) {
                                    input.editorOptions.height = sc.height * $scope.scaleY + 2
                                    input.editorOptions.width = sc.width * $scope.scaleX + 2
                                }
                                updateInput(number, sc, $scope.formData[sc.idDataType])
                            })
                        }
                        if ($scope.gotoBtns) {
                            $scope.gotoBtns.forEach(btn => {
                                var number = btn.schemaNumber;
                                var sc = $scope.schemaModel.schemaConfiguration[number]
                                if (sc) {
                                    btn.height = sc.height * $scope.scaleY + 2
                                    btn.width = sc.width * $scope.scaleX + 2
                                }
                                updateItemPosition(number, sc)
                            })
                        }
                    }


                }, 200)
            }
        }

        $scope.$watch(() => {
            return $element.width() * $element.height()
        }, (width) => {
            resize()
        })

        this.gotoAction = (item) => {
            if (item) {
                $scope.$root.$broadcast(EventsNames.OPEN_TARGET, item.value, $scope.schemaOwner)
            }
        }

        var updateScale = (height, width) => {
            $scope.originalHeight = height;
            $scope.originalWidth = width;

            var actualImg = $element.find('.schema')
            $scope.scaleX = actualImg.width() / $scope.originalWidth
            $scope.scaleY = actualImg.height() / $scope.originalHeight
            $scope.imgPosition = actualImg.position()
        }

        var getImageSize = (byteArray) => {
            var defer = $q.defer()

            var img = new Image()

            img.onload = () => {
                updateScale($scope.originalHeight, $scope.originalWidth)
                defer.resolve()
            }

            img.src = 'data:image/png;base64,' + byteArray

            return defer.promise
        }

        var updateSchema = (schema: SchemaModel) => {
            $scope.schemaModel = schema

            if ($scope.schemaModel.schema) {
                var drawSchema = () => {
                    $timeout(() => {
                        if ($scope.schemaModel.schemaConfiguration) {
                            $scope.schemaModel.schemaConfiguration.forEach(sc => {
                                addToForm(sc)
                            })
                        }

                        $scope.form.promise.then((form) => {
                            $scope.isLoaded = true
                            resize()
                        })
                    })
                }

                if ($scope.schemaModel.height == 0 || $scope.schemaModel.width == 0) {
                    getImageSize($scope.schemaModel.schema).then(() => {
                        drawSchema()
                    })
                } else {
                    $timeout(() => {
                        updateScale($scope.schemaModel.height, $scope.schemaModel.width)
                        drawSchema()
                    })
                }
            } else
                $scope.isLoaded = true
        }

        $scope.$on(EventsNames.UPDATE_SCHEMAS, () => {
            if ($scope.source.id) {
                api.location.getSchema($scope.source.id).then(result => {
                    updateSchema(result)
                })
            }
        })

        var loadSchema = () => {
            $scope.isLoaded = false
            units.then(() => {
                if ($scope.source.id) {
                    api.location.getSchema($scope.source.id).then(result => {
                        updateSchema(result)
                    })
                } else if ($scope.source.data) {
                    updateSchema($scope.source.data)
                }
            })
        }
        loadSchema()

        $scope.formOptions = {
            alignItemLabels: false,
            alignItemLabelsInAllGroups: false,
            bindingOptions: {
                formData: 'formData',
                items: 'items'
            },
            onInitialized: (e) => {
                $scope.form.resolve(e.component)
            }
        }

        $scope.applyButtonOptions = {
            text: i18n('Common', 'Apply'),
            bindingOptions: {
                disabled: 'isApplyButtonDisabled'
            },
            onClick: (e) => {
                var model = <FormValuesModel>{}
                model.fields = []
                model.id = $scope.source.id

                Object.keys($scope.formData).forEach(prop => {
                    var field = new FieldNameValueModel()
                    field.idDataType = parseInt(prop)
                    field.value = $scope.formData[prop]

                    model.fields.push(field)
                })
                var currentMd5 = Md5.init(model)
                if (this.previousModelMd5 !== currentMd5 || this.requestFailed) {
                    this.previousModelMd5 = currentMd5
                    api.location.saveLocation(model).then(result => {
                        if (!result) {
                            CommonHelper.openInfoPopup(i18n('Popup', 'SchemaSaveError'), 'error', 5000)
                            this.requestFailed = true
                        }
                        else {
                            CommonHelper.openInfoPopup(i18n('Popup', 'SchemaSaved'))
                            $scope.isApplyButtonDisabled = true
                            this.requestFailed = false
                        }
                    }).catch(() => {
                        this.requestFailed = true
                    })
                }
            }
        }

        var num = 0
        var addToForm = (item: SchemaElement) => {
            if (item.idDataType != null && item.idDataType != undefined) $scope.formData[item.idDataType] = item.value
            addValidationRules(item, num++)
        }

        var updateItemPosition = (number: number, item: SchemaElement) => {
            if ($scope.imgPosition) {
                var itemBox = $element.find('.item-box' + '-' + $scope.id + '-' + number)
                itemBox.css({
                    position: 'absolute',
                    top: $scope.imgPosition.top + item.y * $scope.scaleY + 'px',
                    left: $scope.imgPosition.left + item.x * $scope.scaleX + 'px',
                    'font-size': item.height * $scope.scaleY + 'px',
                    'line-height': '70%',
                    width: item.width * $scope.scaleX + 2 + 'px',
                    height: item.height * $scope.scaleY + 2 + 'px',
                    opacity: 1
                })

                itemBox.find('.dx-button-text').css({
                    width: item.width * $scope.scaleX + 'px',
                    height: item.height * $scope.scaleY + 'px',
                    'font-size': item.height * $scope.scaleY * 0.6 + 'px',
                })
            }
        }

        var updateInput = (number: number, item: SchemaElement, curentValue: any) => {
            if ($scope.imgPosition) {
                var inputBox = $element.find('.input-box' + '-' + $scope.id + '-' + number)

                inputBox.css({
                    position: 'absolute',
                    top: $scope.imgPosition.top + item.y * $scope.scaleY + 'px',
                    left: $scope.imgPosition.left + item.x * $scope.scaleX + 'px',
                    'font-size': item.height * $scope.scaleY + 'px',
                    opacity: 1,
                    height: item.height * $scope.scaleY + 'px'
                })

                inputBox.find('.dx-textbox').css({
                    width: item.width * $scope.scaleX + 2 + 'px',
                    height: item.height * $scope.scaleY + 2 + 'px'
                })

                inputBox.find('.dx-checkbox').css({
                    width: item.height * $scope.scaleY + 2 + 'px',
                    height: item.height * $scope.scaleY + 2 + 'px',
                })

                inputBox.find('img').css({
                    width: item.width * $scope.scaleX + 'px',
                    height: item.height * $scope.scaleY + 'px',
                })

                var isChanged = false
                item.elementsApperance.forEach(ea => {
                    isChanged = updateInputOnCheckCondition(ea, inputBox, curentValue, isChanged)
                })

            }
        }

        var changeBackgroundColor = (input: JQuery, color: string) => {
            //input.find('label').find('.dx-field-item-label-text').css('color', color)
            input.find('input').css('background-color', color)

            input.find('.dx-checkbox').css('background-color', color)

        }

        var updateInputOnCheckCondition = (elementApperance: SchemaElementApperance, input: JQuery, currentValue: any, isChanged: boolean = false) => {
            var result = checkCondition(elementApperance, currentValue)
            if (result) {
                changeBackgroundColor(input, elementApperance.color)
            }
            else if (isChanged) { //WHY we set WHITE color???????????
                changeBackgroundColor(input, '#fff')
            }
            return result
        }

        var checkCondition = (elementApperance: SchemaElementApperance, currentValue: any) => {
            switch (elementApperance.condition) {
                case CommonHelper.greaterThan:
                    if (currentValue > elementApperance.constraint1) {
                        return true
                    }
                    break
                case CommonHelper.greaterOrEqual:
                    if (currentValue >= elementApperance.constraint1) {
                        return true
                    }
                    break
                case CommonHelper.lowerThan:
                    if (currentValue < elementApperance.constraint1) {
                        return true
                    }
                    break
                case CommonHelper.lowerOrEqual:
                    if (currentValue <= elementApperance.constraint1) {
                        return true
                    }
                    break
                case CommonHelper.equal:
                    if (angular.equals(currentValue, elementApperance.constraint1)) {
                        return true
                    }
                    break
                case CommonHelper.notEqual:
                    if (currentValue != elementApperance.constraint1) {
                        return true
                    }
                    break
                default:
                    var str = elementApperance.condition.trim();
                    return (!str || 0 === str.length)
            }
            return false
        }

        var createInputItem = (editorType: string, number: number, item: SchemaElement, callback: (input) => void) => {
            localDictionary.getIdUnitByIdDataType(item.idDataType).then(unitId => {

                var unitName = ''
                if (item.isUnitVisible && unitId) {
                    for (var i = 0; i < $scope.units.length; i++) {
                        var unit = $scope.units[i]
                        if (unit.id == unitId) {
                            unitName = unit.caption
                            break
                        }
                    }
                }

                var description = ''
                var labelLocation = 'right'
                var showColon = false
                if (item.description) {
                    description = item.description
                    labelLocation = 'left'
                    showColon = true
                }

                let fontColor: string = ThemeHelper.getTheme(userSession).defaultFontColor || '#000'
                var image
                if (item.elementsApperance) {
                    var conditionValue: any = item.value
                    if (conditionValue == null || conditionValue == undefined) conditionValue = {}
                    item.elementsApperance.forEach(ea => {
                        if (checkCondition(ea, conditionValue)) {
                            if (ea.color) {
                                fontColor = ea.color
                            }
                            if (ea.image) {
                                var img = new Image(item.width, item.height)
                                img.src = "data:image/png;base64," + ea.image
                                image = img
                            }
                        }
                    })
                }

                var itemValue = ''
                if (image) {
                    itemValue = image.outerHTML
                } else {
                    if (item.value != undefined && item.value != null) {
                        var column = localDictionary.getDataTypesSync([item.idDataType])[0]
                        if (column != null && column.type == CommonHelper.datetime && item.value.length > 2) {
                            itemValue = moment(item.value).format(window['simax'].getDateTimeFormat('DATE_TIME_FORMAT_MOMENTJS', column.id))
                        } else if (column != null && column.type == CommonHelper.date && item.value.length > 2) {
                            itemValue = moment(item.value).format(window['simax'].getDateTimeFormat('DATE_FORMAT_MOMENTJS', column.id))
                        } else {
                            itemValue = String(item.value)
                        }
                    } else {
                        itemValue = '-'
                    }
                }

                //!item.isEditable,
                var input = {
                    schemaNumber: number,
                    cssClass: 'input-box input-box' + '-' + $scope.id + '-' + number,

                    dataField: item.idDataType,
                    editorType: editorType,

                    desciption: description,
                    unitText: unitName,
                    labelLocation: labelLocation,

                    editorOptions: {
                        width: item.width * $scope.scaleX + 2,
                        height: item.height * $scope.scaleY + 2,
                        hint: window['config'].DEBUG_SCHEMA == true ? formatDebugHint(item) : null,
                        readOnly: true,
                        value: item.value,
                        onChange: (e) => {
                            $scope.isApplyButtonDisabled = false
                            var input = $element.find('.input-box' + '-' + $scope.id + '-' + number)

                            var isChanged = true
                            item.elementsApperance.forEach(ea => {
                                isChanged = updateInputOnCheckCondition(ea, input, e.model.formData[item.idDataType], isChanged)
                            })

                            $scope.formData = e.model.formData
                        }
                    },
                    label: {
                        location: labelLocation,
                        text: description + ' ' + unitName,
                        showColon: showColon,
                        visible: true
                    },
                }

                if ((($scope.source.isReadOnly || !item.isEditable) && editorType.indexOf('dxCheckBox') < 0) || item.valueHidden || image) {
                    var valueHtml = ''
                    if (description.length > 0) {
                        if (itemValue.length > 0 && !item.valueHidden) {
                            valueHtml = description + ' ' + unitName + ': ' + itemValue
                        } else {
                            valueHtml = description + ' ' + unitName
                        }
                    } else {
                        if (itemValue.length > 0 && !item.valueHidden) {
                            valueHtml = itemValue + ' ' + unitName
                        } else {
                            valueHtml = unitName
                        }

                    }
                    var title = window['config'].DEBUG_SCHEMA == true ? 'title="' + formatDebugHint(item) + '"' : ''
                    input['template'] = '<label style="color: ' + fontColor + '" ' + title + '>' + valueHtml + '</label>'
                    input.label.visible = false
                }

                callback(input)
            })
        }

        var formatDebugHint = (item: SchemaElement) => {

            var idDatatype = item.idDataType ? item.idDataType : 'no'
            var hint = 'IdDataType = ' + idDatatype + ' | ' +
                'XxY = ' + item.x + 'x' + item.y + ' | ' +
                'WxH = ' + item.width + 'x' + item.height

            return hint
        }

        var createButtonItem = (number: number, item: SchemaElement, callback: (button) => void) => {

            var value = item.value
            if (value.search('CurrentObjectId') > 0) {
                var objectId = $scope.source.id
                value = value.replace('CurrentObjectId', objectId)
            }
            if (value.search('SchemaObjectId') > 0) {
                var objectId = <number>$scope.schemaModel.idObject
                value = value.replace('SchemaObjectId', objectId)
            }

            var button: SchButton
            button = {
                schemaNumber: number,
                value: value,
                cssClass: 'goto-button item-box' + '-' + $scope.id + '-' + number,
                width: item.width * $scope.scaleX + 2,
                height: item.height * $scope.scaleY + 2,
                text: item.description,
                hint: window['config'].DEBUG_SCHEMA == true ? formatDebugHint(item) : item.description,
                onClick: (e) => {
                    this.gotoAction(button)
                },
                image: []
            }

            if (item.elementsApperance) {
                var conditionValue: any = item.value
                if (conditionValue == null || conditionValue == undefined) conditionValue = {}
                item.elementsApperance.forEach(ea => {
                    if (checkCondition(ea, conditionValue)) {
                        if (ea.color) {
                            var color = ea.color.trim();
                            if (color && 0 < color.length) {
                                button.elementAttr = {
                                    style: "color: " + color
                                }
                            }
                        }
                        if (ea.image) {
                            button.icon = 'data:image/png;base64,' + ea.image
                            button.text = ""
                        }
                    }
                })
            }

            callback(button)
        }

        var addValidationRules = (item: SchemaElement, number: number) => {
            switch (item.elementType) {
                case CommonHelper.SchemaElementType.Redirection:
                    createButtonItem(number, item, button => {
                        $scope.gotoBtns.push(button)
                    })
                    break
                default:
                    switch (item.type) {
                        case CommonHelper.integer:
                            createInputItem('dxNumberBox', number, item, input => {
                                input['validationRules'] = []
                                input['validationRules'].push({
                                    type: 'pattern',
                                    pattern: '^[0-9]{0,}$',
                                    message: i18n('Common', 'IntegerField')
                                })
                                $scope.items.push(input)
                            })

                            break
                        case CommonHelper.real:
                            createInputItem('dxNumberBox', number, item, input => {
                                input['validationRules'] = []
                                input['validationRules'].push({
                                    type: 'numeric',
                                    message: i18n('Common', 'NumericField')
                                })
                                $scope.items.push(input)
                            })
                            break
                        case CommonHelper.boolean:
                            createInputItem('dxCheckBox', number, item, input => {
                                input['validationRules'] = []
                                input['validationRules'].push({
                                    type: 'boolean',
                                    message: i18n('Common', 'BooleanField')
                                })
                                $scope.items.push(input)
                            })
                            break
                        case CommonHelper.string:
                        default:
                            createInputItem('dxTextBox', number, item, input => {
                                $scope.items.push(input)
                            })
                            break
                    }
            }
        }
    }]

    replace = true
}